import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error("UI crash", err, info?.componentStack); }
  componentDidUpdate(prev) { if (prev.location !== this.props.location && this.state.err) this.setState({ err: null }); }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="ui-crash">
        <div className="max-w-md w-full border border-white/10 bg-[#121212] p-6">
          <div className="font-mono-data text-xs tracking-widest text-[#FF6A00]">// SOMETHING BROKE</div>
          <h1 className="mt-1 font-display font-black text-3xl uppercase tracking-tighter text-white">Dropped a tool</h1>
          <p className="mt-2 text-sm text-zinc-400">That screen hit an error. Nothing's lost — reload or head home and try again.</p>
          <p className="mt-2 text-[11px] font-mono-data text-zinc-600 break-words" data-testid="ui-crash-msg">{String(this.state.err?.message || this.state.err).slice(0, 200)}</p>
          <div className="mt-5 flex gap-2">
            <button onClick={() => window.location.reload()} className="flex-1 px-4 py-3 bg-[#FF6A00] text-black text-xs font-black uppercase tracking-widest hover:bg-white" data-testid="ui-crash-reload">Reload</button>
            <a href="/dashboard" className="flex-1 text-center px-4 py-3 border border-white/20 text-white text-xs font-bold uppercase tracking-widest hover:border-[#FF6A00]" data-testid="ui-crash-home">Home</a>
          </div>
        </div>
      </div>
    );
  }
}
